import en from './en/translations.json';
import es from './es/translations.json';

export default { en, es };
